module.exports = __webpack_public_path__ + "img/生病.7689f24f.png";